<template>
  <w-icon-wrapper icon-name='work-module-overview-icon'>
    <path
      id="Pfad_55635"
      data-name="Pfad 55635"
      d="M0,7.3H7.3V0H0ZM2.087,2.087h3.13v3.13H2.087Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55636"
      data-name="Pfad 55636"
      d="M8.348,7.3h7.3V0h-7.3Zm2.087-5.217h3.13v3.13h-3.13Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55637"
      data-name="Pfad 55637"
      d="M16.7,0V7.3H24V0Zm5.217,5.217h-3.13V2.087h3.13Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55638"
      data-name="Pfad 55638"
      d="M0,15.652H7.3v-7.3H0Zm2.087-5.217h3.13v3.13H2.087Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55639"
      data-name="Pfad 55639"
      d="M8.348,15.652h7.3v-7.3h-7.3Zm2.087-5.217h3.13v3.13h-3.13Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55640"
      data-name="Pfad 55640"
      d="M16.7,15.652H24v-7.3H16.7Zm2.087-5.217h3.13v3.13h-3.13Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55641"
      data-name="Pfad 55641"
      d="M0,24H7.3V16.7H0Zm2.087-5.217h3.13v3.13H2.087Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55642"
      data-name="Pfad 55642"
      d="M8.348,24h7.3V16.7h-7.3Zm2.087-5.217h3.13v3.13h-3.13Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55643"
      data-name="Pfad 55643"
      d="M16.7,24H24V16.7H16.7Zm2.087-5.217h3.13v3.13h-3.13Z"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconModuleOverview' };
</script>
